import { IMfaAuthenticator } from '../../../types/auth'
import { createSelector } from 'reselect'
import { RootState } from '../../index'

export const selectAuthStatus = (state: RootState): boolean =>
	state.auth?.auth || false

export const selectOobChannel = (state: RootState): string =>
	state.auth?.oobChannel || ''

export const selectMfaToken = (state: RootState): string | null =>
	state.auth?.mfaToken || null

export const selectMfaRequiredError = (state: RootState): string | null =>
	state.auth?.mfaRequiredError || null

const authenticators = (state: RootState): Array<IMfaAuthenticator> =>
	state.auth?.authenticators || []

export const selectOOBChannel = (state: RootState): string =>
	state.auth?.oobChannel || ''

export const selectOOBCode = (state: RootState): string =>
	state.auth?.oobCode || ''

export const selectSkipMFAFlag = (state: RootState): boolean =>
	state.auth?.skipMfa

export const selectAuthenticatorId = createSelector(
	authenticators,
	selectOOBChannel,
	(authenticators: Array<IMfaAuthenticator>, oobChannel: string) => {
		if (!oobChannel) return ''
		if (!authenticators.length) return ''

		const authenticator = authenticators.find(
			(item: IMfaAuthenticator) => item.oob_channel === oobChannel
		)

		return authenticator ? authenticator.id : ''
	}
)
